import { Loader } from 'component/Loader/Loader'
import { Space } from 'component/Space'
import { Gap } from 'component/Space/Gap'
import { Typo } from 'component/Typo'
import { Icon } from 'icon/Icon'
import { observer } from 'mobx-react-lite'
import css from 'page/None/None.module.scss'

export const None = observer(() => {
  return (
    <Space className={css.root} center>
      <Loader />
      <Space className={css.preload} center>
        <Icon name="photo_camera" size={20} tertiary />
        <Gap width={8} />
        <Typo size={16} center tertiary>
          Try on
        </Typo>
      </Space>
    </Space>
  )
})
